// src/redux/wpThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import swal from "sweetalert";

const pageAccessToken = Cookies.get("fbToken");
const accessToken = Cookies.get("token");
const token = Cookies.get("token");
// const BASE_URL = process.env.REACT_APP_BASE_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const facebookPageId = "387246711135597";

export const getConnectedWABAs = createAsyncThunk(
  "wp/getConnectedWABAs",
  async (pageId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${facebookPageId}`,
        {
          params: {
            fields: "connected_whatsapp_business_accounts",
            access_token: pageAccessToken,
          },
        }
      );
      return response.data.connected_whatsapp_business_accounts;
    } catch (error) {
      console.error("Error fetching connected WABAs:", error.response?.data);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getConversationList = createAsyncThunk(
  "wp/getConversationList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/whatsapp/get-conversation`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(response, "---------------wpgetConversationList----------");

      return response.data.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const sendWpMessage = createAsyncThunk(
  "wp/sendWpMessage",
  async (messageData, { rejectWithValue }) => {
    console.log(messageData,"---messageData-----");
    try {
      alert("wp api")
      const response = await axios.post(
        `${BASE_URL}/whatsapp/sendMessage`,
        { messageData },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(response, "-----------sendWpMessage-------------");
      return response.data;
    } catch (error) {
      console.error("Error sending WhatsApp message:", error);
      return rejectWithValue(error);
    }
  }
);

export const getConversationById = createAsyncThunk(
  "wp/getConversationById",
  async (id, { rejectWithValue }) => {
    console.log(id, "-----------------------id--------------------------");
    try {
      const response = await axios.get(
        `${BASE_URL}/whatsapp/get-conversation/${id}`
      );
      console.log(response, "------------------>----------->");
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      console.error("Error getting conversation by ID:", error);
      return rejectWithValue(error);
    }
  }
);

// export const WPDisconnect = createAsyncThunk(
//   "wp/WPDisconnect",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${BASE_URL}/user/wp/disconect`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       return response.data;
//     } catch (error) {
//       console.error("Error disconnecting WP:", error);
//       return rejectWithValue(error);
//     }
//   }
// );

export const wpDisconnect = createAsyncThunk(
  "wp/wpDisconnect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/user/wp/disconnect`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response, "----------wpDisconnect=------0-");
      return response.data;
    } catch (error) {
      console.log(error, "----------error=------0-");

      return rejectWithValue(error);
    }
  }
);

export const updateWpStatus = createAsyncThunk(
  "wp/updateWpStatus",
  async (conversationId, { rejectWithValue }) => {
    console.log(conversationId, "------------conversationId---------");
    try {
      const response = await axios.patch(
        `${BASE_URL}/whatsapp/update-status/${conversationId}`
      );
      console.log(response, "______________data_______________");
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.error("Error updating WP status:", error);
      return rejectWithValue(error);
    }
  }
);

export const getTemplates = createAsyncThunk(
  "wp/getTemplates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/whatsapp/template`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(response,"--------------getTemplates------------")
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getTemplatesById = createAsyncThunk(
  "wp/getTemplatesById",
  async (templateId, { rejectWithValue }) => {
    try {
      console.log(templateId, "templateIdtemplateId");
      const response = await axios.get(
        `${BASE_URL}/whatsapp/template/${templateId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const createTemplates = createAsyncThunk(
  "wp/createTemplates",
  async (template, { rejectWithValue }) => {
    alert("tempplate")
    try {
      // console.log(template, "templateIdtemplateId");
      const response = await axios.post(
        `${BASE_URL}/whatsapp/template/create`,
        template,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return response.data
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
